import { IAgrupadoPorConta, IRelatorio, IResumo, IDetalhesErro, IDetalhesAviso, IDetalhesRecomendacao, IDetalhesPendente, IEcd, IDetalhesMatch, IMemoriaCalculo, IDetalhesConciliado } from "../interfaces/IRelatorio";
import api from "./Api";
import Swal from 'sweetalert2';
import { IEsteira } from "../interfaces/IRelatorioCliente";

class RelatoriosService {

  async obterTodosClientes(funcaoSucesso?: (data: IEsteira[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result } = await api.get('Esteira/GetEmpresas');

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });
    
      return true;
    } catch (error: any) {
      Swal.fire({
          text: error.message,
          timer: 4000,
          icon: 'error',
          showConfirmButton: false
      });

      return false;
    }
  }

  async obterEmpresasPorClienteID(clienteID: number, funcaoSucesso?: (data: IEsteira[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result } = await api.get('Esteira/ListarPorClienteID/'+clienteID);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });
    
      return true;
    } catch (error: any) {
      Swal.fire({
          text: error.message,
          timer: 4000,
          icon: 'error',
          showConfirmButton: false
      });

      return false;
    }
  }

  async obterEmpresasPorUsuarioID(usuarioID: number, funcaoSucesso?: (data: IEsteira[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result } = await api.get('Esteira/ListarPorUsuarioID/'+usuarioID);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });
    
      return true;
    } catch (error: any) {
      Swal.fire({
          text: error.message,
          timer: 4000,
          icon: 'error',
          showConfirmButton: false
      });

      return false;
    }
  }

  async excluirCliente(id: number, funcaoSucesso?: (data: IResumo) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result } = await api.delete(`Esteira/ExcluirPorEmpresaID/${id}`);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });
    
      return true;
    } catch (error: any) {
      Swal.fire({
          text: error.message,
          timer: 4000,
          icon: 'error',
          showConfirmButton: false
      });

      return false;
    }
  }

  async dadosDashboard(id: number, dataInicio: Date, dataFinal: Date, funcaoSucesso?: (data: IResumo) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const param = {
        empresaId: id,
        inicio: new Date(dataInicio).toISOString().substring(0, 10),
        fim: new Date(dataFinal).toISOString().substring(0, 10)
      }
      const { data: result } = await api.post('Relatorio/Resumo', param);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });
    
      return true;
    } catch (error: any) {
      Swal.fire({
          text: error.message,
          timer: 4000,
          icon: 'error',
          showConfirmButton: false
      });

      return false;
    }
  }

  async dadosResumidos(id: number, dataInicio: Date, dataFinal: Date, funcaoSucesso?: (data: IRelatorio[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const param = {
        empresaId: id,
        inicio: new Date(dataInicio).toISOString().substring(0, 10),
        fim: new Date(dataFinal).toISOString().substring(0, 10)
      }
      const { data: result } = await api.post('Relatorio/DadosResumidos', param);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });
    
      return true;
    } catch (error: any) {
      Swal.fire({
          text: error.message,
          timer: 4000,
          icon: 'error',
          showConfirmButton: false
      });

      return false;
    }
  }

  async dadosEcd(id: number, funcaoSucesso?: (data: IEcd[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
        // const param = {
        //   empresaId: id,
        //   inicio: new Date(dataInicio).toISOString().substring(0, 10),
        //   fim: new Date(dataFinal).toISOString().substring(0, 10)
        // }
      const { data: result } = await api.get(`Arquivo/GetECDsByEmpresaID/${id}`);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });
    
      return true;
    } catch (error: any) {
      Swal.fire({
          text: error.message,
          timer: 4000,
          icon: 'error',
          showConfirmButton: false
      });

      return false;
    }
  }
      
  async agrupadoPorConta(id: number, dataInicio: Date, dataFinal: Date, contaEmpresa: string, funcaoSucesso?: (data: IAgrupadoPorConta) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const param = {
        empresaId: id,
        inicio: new Date(dataInicio).toISOString().substring(0, 10),
        fim: new Date(dataFinal).toISOString().substring(0, 10),
        contaEmpresa: contaEmpresa
      }
      const { data: result } = await api.post('Relatorio/AgrupadoPorConta', param);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });
    
      return true;
    } catch (error: any) {
      Swal.fire({
          text: error.message,
          timer: 4000,
          icon: 'error',
          showConfirmButton: false
      });

      return false;
    }
  }
  
  async detalhesErros(id: number, dataInicio: Date, dataFinal: Date, funcaoSucesso?: (data: IDetalhesErro[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const param = {
        empresaId: id,
        inicio: new Date(dataInicio).toISOString().substring(0, 10),
        fim: new Date(dataFinal).toISOString().substring(0, 10)
      }
      const { data: result } = await api.post('Relatorio/DetalhesErros', param);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });
    
      return true;
    } catch (error: any) {
      Swal.fire({
          text: error.message,
          timer: 4000,
          icon: 'error',
          showConfirmButton: false
      });

      return false;
    }
  }
    
  async detalhesAvisos(id: number, dataInicio: Date, dataFinal: Date, funcaoSucesso?: (data: IDetalhesAviso[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const param = {
        empresaId: id,
        inicio: new Date(dataInicio).toISOString().substring(0, 10),
        fim: new Date(dataFinal).toISOString().substring(0, 10)
      }
      const { data: result } = await api.post('Relatorio/DetalhesAvisos', param);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });
    
      return true;
    } catch (error: any) {
      Swal.fire({
          text: error.message,
          timer: 4000,
          icon: 'error',
          showConfirmButton: false
      });

      return false;
    }
  }
    
  async detalhesRecomendacoes(id: number, dataInicio: Date, dataFinal: Date, funcaoSucesso?: (data: IDetalhesRecomendacao[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const param = {
        empresaId: id,
        inicio: new Date(dataInicio).toISOString().substring(0, 10),
        fim: new Date(dataFinal).toISOString().substring(0, 10)
      }
      const { data: result } = await api.post('Relatorio/DetalhesRecomendacoes', param);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });
    
      return true;
    } catch (error: any) {
      Swal.fire({
          text: error.message,
          timer: 4000,
          icon: 'error',
          showConfirmButton: false
      });

      return false;
    }
  }

  async detalhesPendentes(id: number, dataInicio: Date, dataFinal: Date, funcaoSucesso?: (data: IDetalhesPendente[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const param = {
        empresaId: id,
        inicio: new Date(dataInicio).toISOString().substring(0, 10),
        fim: new Date(dataFinal).toISOString().substring(0, 10)
      }
      const { data: result } = await api.post('Relatorio/DetalhesPendentes', param);

      result.forEach((x: IDetalhesPendente, index: number) => x.id = index);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });
    
      return true;
    } catch (error: any) {
      Swal.fire({
          text: error.message,
          timer: 4000,
          icon: 'error',
          showConfirmButton: false
      });

      return false;
    }
  }

  async detalhesConciliados(id: number, codigoEmpresa: number, dataInicio: Date, dataFinal: Date, funcaoSucesso?: (data: IDetalhesConciliado) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const param = {
        empresaId: id,
        inicio: new Date(dataInicio).toISOString().substring(0, 10),
        fim: new Date(dataFinal).toISOString().substring(0, 10),
        codigoEmpresa: codigoEmpresa.toString()
      }
      const { data: result } = await api.post('Relatorio/DetalhesConciliados', param);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });
    
      return true;
    } catch (error: any) {
      Swal.fire({
          text: error.message,
          timer: 4000,
          icon: 'error',
          showConfirmButton: false
      });

      return false;
    }
  }

  async detalhesMatches(id: number, dataInicio: Date, dataFinal: Date, funcaoSucesso?: (data: IDetalhesMatch) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const param = {
        empresaId: id,
        inicio: new Date(dataInicio).toISOString().substring(0, 10),
        fim: new Date(dataFinal).toISOString().substring(0, 10)
      }
      const { data: result } = await api.post('Relatorio/DetalhesMatches', param);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });
    
      return true;
    } catch (error: any) {
      Swal.fire({
          text: error.message,
          timer: 4000,
          icon: 'error',
          showConfirmButton: false
      });

      return false;
    }
  }

  async memoriaCalculo(id: number, funcaoSucesso?: (data: IMemoriaCalculo[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result } = await api.get(`Relatorio/MemoriaCalculo/${id}`);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });
    
      return true;
    } catch (error: any) {
      Swal.fire({
          text: error.message,
          timer: 4000,
          icon: 'error',
          showConfirmButton: false
      });

      return false;
    }
  }
  
  async memoriaCalculoAlgoritimoConstancia(id: number, funcaoSucesso?: (data: IMemoriaCalculo[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result } = await api.get(`Relatorio/MemoriaCalculoAlgoritimoConstancia/${id}`);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });
    
      return true;
    } catch (error: any) {
      Swal.fire({
          text: error.message,
          timer: 4000,
          icon: 'error',
          showConfirmButton: false
      });

      return false;
    }
  }
  async pegarUrlImpressao(id: number, listaContaEmpresa: string[], dataInicio: Date, dataFinal: Date, funcaoSucesso?: (data: string[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const param = {
        empresaId: id,
        contasEmpresa: listaContaEmpresa,
        inicio: new Date(dataInicio).toISOString().substring(0, 10),
        fim: new Date(dataFinal).toISOString().substring(0, 10)
      }
      const { data: result } = await api.post('Relatorio/Impressao', param);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });
    
      return true;
    } catch (error: any) {
      Swal.fire({
          text: error.message,
          timer: 4000,
          icon: 'error',
          showConfirmButton: false
      });

      return false;
    }
  }

  async exportarTodosExcel(id: number, dataInicio: Date, dataFinal: Date, funcaoSucesso?: (data: string[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const param = {
        empresaId: id,
        inicio: new Date(dataInicio).toISOString().substring(0, 10),
        fim: new Date(dataFinal).toISOString().substring(0, 10)
      }
      const { data: result } = await api.post('Relatorio/GerarExcel', param);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });
    
      return true;
    } catch (error: any) {
      Swal.fire({
          text: error.message,
          timer: 4000,
          icon: 'error',
          showConfirmButton: false
      });

      return false;
    }
  }
}

export default new RelatoriosService();